module.exports = __webpack_public_path__ + "assets/img/tx15.1e1b9917.jpg";